'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChildrenOptions = function (_Component) {
  (0, _inherits3.default)(ChildrenOptions, _Component);

  function ChildrenOptions(props) {
    (0, _classCallCheck3.default)(this, ChildrenOptions);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ChildrenOptions.__proto__ || (0, _getPrototypeOf2.default)(ChildrenOptions)).call(this, props));

    _this.state = {
      shouldShowBubble: false
    };
    _this.handleDocumentClick = _this.handleDocumentClick.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(ChildrenOptions, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.addEventListener('click', this.handleDocumentClick, true);
      document.addEventListener('focus', this.handleDocumentClick, true);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.handleDocumentClick, true);
      document.removeEventListener('focus', this.handleDocumentClick, true);
    }
  }, {
    key: 'handleDocumentClick',
    value: function handleDocumentClick(event) {
      // hide the bubble list while clicking outside the visible bubble div
      if (!this.bubbleList || !this.bubbleList.contains(event.target) && this.state.shouldShowBubble && !this.selectLabelDOM.contains(event.target) && this.state.shouldShowBubble) {
        this.setState({ shouldShowBubble: false });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { className: 'searchform-children' },
        _react2.default.createElement(
          'label',
          {
            ref: function ref(selectLabel) {
              _this2.selectLabelDOM = selectLabel;
            },
            htmlFor: 'children-input',
            className: 'searchform-label'
          },
          _react2.default.createElement(
            'span',
            { className: 'for-reader' },
            this.props.i18n.searchForm.children
          ),
          _react2.default.createElement(
            'select',
            {
              className: 'children-input',
              name: 'children',
              value: this.props.child,
              onFocus: function onFocus() {
                _this2.setState({
                  shouldShowBubble: _this2.props.child > 0
                });
              },
              onChange: function onChange(evt) {
                var child = Number(evt.target.value) || 0;
                var childrenOptions = _this2.props.childrenOptions;
                var diff = childrenOptions.length - child;
                while (diff !== 0) {
                  if (diff > 0) {
                    childrenOptions.pop();
                    diff -= 1;
                  } else if (diff < 0) {
                    childrenOptions.push({
                      age: 0,
                      bed: 0
                    });
                    diff += 1;
                  }
                }
                _this2.setState({
                  shouldShowBubble: child > 0
                });
                _this2.props.onChange(String(child), childrenOptions);
              }
            },
            _react2.default.createElement(
              'option',
              { value: 0 },
              this.props.i18n.searchForm.numOfChild.replace(/\{child\}/, 0)
            ),
            _react2.default.createElement(
              'option',
              { value: 1 },
              this.props.i18n.searchForm.numOfChild.replace(/\{child\}/, 1)
            ),
            _react2.default.createElement(
              'option',
              { value: 2 },
              this.props.i18n.searchForm.numOfChildren.replace(/\{child\}/, 2)
            ),
            _react2.default.createElement(
              'option',
              { value: 3 },
              this.props.i18n.searchForm.numOfChildren.replace(/\{child\}/, 3)
            ),
            _react2.default.createElement(
              'option',
              { value: 4 },
              this.props.i18n.searchForm.numOfChildren.replace(/\{child\}/, 4)
            ),
            _react2.default.createElement(
              'option',
              { value: 5 },
              this.props.i18n.searchForm.numOfChildren.replace(/\{child\}/, 5)
            ),
            _react2.default.createElement(
              'option',
              { value: 6 },
              this.props.i18n.searchForm.numOfChildren.replace(/\{child\}/, 6)
            ),
            _react2.default.createElement(
              'option',
              { value: 7 },
              this.props.i18n.searchForm.numOfChildren.replace(/\{child\}/, 7)
            ),
            _react2.default.createElement(
              'option',
              { value: 8 },
              this.props.i18n.searchForm.numOfChildren.replace(/\{child\}/, 8)
            ),
            _react2.default.createElement(
              'option',
              { value: 9 },
              this.props.i18n.searchForm.numOfChildren.replace(/\{child\}/, 9)
            ),
            _react2.default.createElement(
              'option',
              { value: 10 },
              this.props.i18n.searchForm.numOfChildren.replace(/\{child\}/, 10)
            )
          )
        ),
        this.state.shouldShowBubble ? _react2.default.createElement(
          'div',
          { className: 'select-children-options', style: { display: 'block' }, ref: function ref(bubbleList) {
              _this2.bubbleList = bubbleList;
            } },
          _react2.default.createElement(
            'div',
            { className: 'bubble' },
            _react2.default.createElement(
              'label',
              { className: 'label', htmlFor: 'select-children-age' },
              this.props.i18n.searchForm.age,
              ':'
            ),
            _react2.default.createElement(
              'ol',
              { className: 'list-ordered' },
              this.props.childrenOptions.map(function (field, index) {
                return _react2.default.createElement(
                  'li',
                  { className: 'search-options-2cols', key: index },
                  _react2.default.createElement(
                    'div',
                    { className: 'search-option-col3' },
                    _react2.default.createElement(
                      'select',
                      {
                        id: 'select-children-age',
                        className: 'input-mini',
                        value: _this2.props.childrenOptions[index].age,
                        onChange: function onChange(evt) {
                          var childrenOptions = _this2.props.childrenOptions.map(function (field, _index) {
                            var age = Number(evt.target.value);
                            return index === _index ? {
                              age: age,
                              bed: age < 6 ? field.bed : 1
                            } : field;
                          });
                          _this2.props.onChange(String(_this2.props.child), childrenOptions);
                        }
                      },
                      _react2.default.createElement(
                        'option',
                        null,
                        '0'
                      ),
                      _react2.default.createElement(
                        'option',
                        null,
                        '1'
                      ),
                      _react2.default.createElement(
                        'option',
                        null,
                        '2'
                      ),
                      _react2.default.createElement(
                        'option',
                        null,
                        '3'
                      ),
                      _react2.default.createElement(
                        'option',
                        null,
                        '4'
                      ),
                      _react2.default.createElement(
                        'option',
                        null,
                        '5'
                      ),
                      _react2.default.createElement(
                        'option',
                        null,
                        '6'
                      ),
                      _react2.default.createElement(
                        'option',
                        null,
                        '7'
                      ),
                      _react2.default.createElement(
                        'option',
                        null,
                        '8'
                      ),
                      _react2.default.createElement(
                        'option',
                        null,
                        '9'
                      ),
                      _react2.default.createElement(
                        'option',
                        null,
                        '10'
                      ),
                      _react2.default.createElement(
                        'option',
                        null,
                        '11'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'search-option-col9' },
                    _react2.default.createElement(
                      'label',
                      { className: 'hide', htmlFor: 'select-children-beds' },
                      'select-children-beds'
                    ),
                    _react2.default.createElement(
                      'select',
                      {
                        id: 'select-children-beds',
                        className: 'input-medium',
                        value: _this2.props.childrenOptions[index].bed,
                        disabled: field.age > 5,
                        onChange: function onChange(evt) {
                          var childrenOptions = _this2.props.childrenOptions.map(function (field, _index) {
                            return index === _index ? {
                              age: field.age,
                              bed: evt.target.value
                            } : field;
                          });
                          _this2.props.onChange(String(_this2.props.child), childrenOptions);
                        }
                      },
                      _react2.default.createElement(
                        'option',
                        { value: 1 },
                        _this2.props.i18n.searchForm.withBed
                      ),
                      _react2.default.createElement(
                        'option',
                        { value: 0 },
                        _this2.props.i18n.searchForm.withoutBed
                      )
                    )
                  )
                );
              })
            )
          )
        ) : null
      );
    }
  }]);
  return ChildrenOptions;
}(_react.Component); // ChildrenOptions


ChildrenOptions.propTypes = {
  i18n: _react.PropTypes.object.isRequired,
  child: _react.PropTypes.string.isRequired,
  childrenOptions: _react.PropTypes.array.isRequired,
  onChange: _react.PropTypes.func
};

exports.default = ChildrenOptions;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ChildrenOptions.js
// module id = 1195
// module chunks = 0